import { forwardRef } from 'react'
import './About.css'

interface AboutProps {
  id: string
}

const About = forwardRef<HTMLDivElement, AboutProps>(({ id }, ref) => {
  return (
    <section
      ref={ref}
      id={id}
      className="about section"
      aria-labelledby="about-title"
    >
      <div className="container">
        <header className="section__header animate-in">
          <h2 id="about-title" className="section__title">
            Om mig – <span className="text-terracotta">Catarina Malmberg</span>
          </h2>
        </header>

        <div className="about__grid grid grid--2">
          <div className="about__image animate-in">
            <img
              src="/images/about-grove.jpg"
              alt=""
              aria-hidden="true"
              className="about__photo"
              loading="lazy"
              decoding="async"
            />
            <img
              src="/images/catarina-portrait.jpg"
              alt="Catarina Malmberg"
              className="about__portrait"
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="about__content animate-in animate-delay-1">
            <div className="about__intro">
              <p>
                Jag erbjuder individuell terapi och parterapi samt behandling och utbildning i grupp,
                utifrån psykodynamiska samtal, affektfokuserad terapi, panikfokuserad psykodynamisk
                terapi (PFPP), mindfulness och ACT på mottagning i centrala Malmö eller online.
              </p>
              <p>
                Jag har många års erfarenhet av en rad olika typer av problematik, så som ångest,
                depression och nedstämdhet, trauma, högkänslig personlighet, stress och utmattning,
                ätstörningar, tvångstankar, låg självkänsla och relationsproblem.
              </p>
              <p>
                Välkommen att kontakta mig på telefon eller mejl för ett första möte. Du behöver inte
                i telefon eller mejl beskriva din problematik om det inte känns bekvämt. Vid ditt första
                besök får du berätta om din problematik, dina bekymmer eller det du vill ha hjälp med.
                Jag lyssnar, ställer frågor och ger en sammanfattning av den bild jag fått av det du
                behöver hjälp med och på vilket sätt jag tänker att vi kan arbeta vidare tillsammans för
                att du ska komma till rätta med det som hindrar dig från att må bra.
              </p>
              <p>
                Till mig kommer man utan remiss och terapin sker helt i egen regi.
              </p>
              <p>
                Mitt förhållningssätt i det terapeutiska arbetet präglas av respekt, ödmjukhet och närvaro.
              </p>
              <p>
                Varmt välkommen!<br />
                Catarina Malmberg
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  )
})

About.displayName = 'About'

export default About